import { TPoint } from 'src/app/project/modules/points/points.model';
import { TColumn } from '../../../columns/column.model';
import { createNumberCostDateInnerCell } from './create-number-cost-date-inner-cell';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';

export function createTotalNumbersCellInnerElement({
  cellNameElement,
  column,
  points,
  isGroupedHeader = false,
  _index,
}: {
  cellNameElement: HTMLElement;
  column: TColumn;
  points: TPoint[];
  isGroupedHeader?: boolean;
  _index?: number;
}): void {
  createNumberCostDateInnerCell({
    cellNameElement,
    column,
    points,
    isGroupedHeader,
    _index,
    type: ECustomFieldType.NUMBERS,
  });
}
